/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react'
import Breadcrumb from './Breadcrumb'
import BreadcrumbOverflow from './BreadcrumbOverflow'
import './breadcrumbs.less'


class Breadcrumbs extends Component {
  getBreadCrumbs = () => {
    let indexOfLastPopOver = -1
    let breadcrumbArray = window.location.pathname.endsWith("/treeviewnew")?this.props.breadCrumbs.slice(0,2):this.props.breadCrumbs;
    breadcrumbArray = breadcrumbArray.filter((v,i,a)=>a.findIndex(v2=>['name'].every(k=>v2[k] ===v[k]))===i);

    breadcrumbArray = breadcrumbArray.filter((bredCrumb) => bredCrumb.name !== undefined)
    if (breadcrumbArray.length > 3) {
      indexOfLastPopOver = breadcrumbArray.length - 3
    }

    return breadcrumbArray.map((crumb, index) => {
      return (
        <Breadcrumb
          item={crumb}
          key={index}
          handleClick={this.props.handleClick}
          isFirstCrumb={index === 0}
          isFinalCrumb={
            index === breadcrumbArray.length - 1
          }
          resetCardPage={this.props.resetCardPage}
        />
      )
    })
  }
  getTitle = () => {
    let breadCrumbsForTooltip = this.props.breadCrumbs.filter((v,i,a)=>a.findIndex(v2=>['name'].every(k=>v2[k] ===v[k]))===i);
    return breadCrumbsForTooltip.reduce((acc, crumb, index) => {
      const isFinalCrumb = index === this.props.breadCrumbs.length - 1
      if (!crumb) {
        return ''
      }
      let title = (acc += crumb.name)
      if (!isFinalCrumb) {
        title += ' > '
      }
    
      return title
    }, '')
  }
  render() {
    let crumbs = this.getBreadCrumbs()
    let title = this.getTitle()

   
    let breadcrumbArray = window.location.pathname.endsWith("/treeviewnew")?this.props.breadCrumbs.slice(0,2):this.props.breadCrumbs;
    breadcrumbArray = breadcrumbArray.filter((v,i,a)=>a.findIndex(v2=>['name'].every(k=>v2[k] ===v[k]))===i);

    breadcrumbArray = breadcrumbArray.filter((bredCrumb) => bredCrumb.name !== undefined)
   
      
    document.title="Operator Console - "+(breadcrumbArray?.[breadcrumbArray?.length - 1]?.name?breadcrumbArray[breadcrumbArray?.length - 1]?.name:"");
    let breadcrumbs = (
      <span className="breadcrumbs" style={{paddingTop:breadcrumbArray.length===1?'0px':'16px'}} title={title}>
        {crumbs}
      </span>
    )
    if (crumbs.length > 3) {
      breadcrumbs = <BreadcrumbOverflow crumbs={crumbs} title={title} />
    }
    return breadcrumbs
  }
}

export default Breadcrumbs
